// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (value: any) => value instanceof Object && value.constructor === Object;
